import { useTranslation } from 'react-i18next'

import { useFetchShopProducts } from '@entities/Product'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'

import { URL_PAGE_CATALOG } from '@shared/contants'
import { LocalizedLink as Link } from '@shared/lib/locale'
import Button from '@shared/ui/button'

import styles from './CartEmpty.module.scss'

export default function EmptyCart () {
  const { t: tc } = useTranslation('common')
  const { t: tcart } = useTranslation('cart')
  const { shopId } = useAddressStore()
  const { products, loading } = useFetchShopProducts({
    shopId,
    page: 1,
    limit: 12,
    sort: {
      fieldName: 'new',
      direction: 1,
    },
  })

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.content__text}>
          <h3 className={styles.title}>{tcart('empty.title')}</h3>
          <p className={styles.description}>
            <Link to={URL_PAGE_CATALOG} className={styles.description__link}>
              {tcart('empty.link')}
            </Link>
            , {tcart('empty.after_link')}
            <br />
            {tcart('empty.search')}
          </p>
        </div>
        <Button to={URL_PAGE_CATALOG} size="large" className={styles.button}>
          {tc('button.catalog', { defaultValue: tc('button.catalog') })}
        </Button>
      </div>
      {products && products.length > 0 && (
        <ProductCarousel
          title={tcart('empty.carousel_title')}
          products={products}
          loading={loading}
          swiperClassName="_navigation-circle cart-big"
        />
      )}
    </div>
  )
}
